import { render, staticRenderFns } from "./SelfAssessmentSubmitReview.vue?vue&type=template&id=e8f181b4&scoped=true&"
import script from "./SelfAssessmentSubmitReview.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentSubmitReview.vue?vue&type=script&lang=js&"
import style0 from "./SelfAssessmentSubmitReview.vue?vue&type=style&index=0&id=e8f181b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f181b4",
  null
  
)

export default component.exports